import React from 'react';
import PropTypes from 'prop-types';

import ProfileLogo from './ProfileLogo';
import FollowButton from './FollowButton';

export default function ProfileTopBar(props) {
    return (
        <section className="panel">
            <div className="media">
                <div className="media__img">
                    <ProfileLogo
                        altText={`${props.profile.companyName} logo`}
                        logo={props.profile.logo}
                    />
                </div>
                <div className="media__body u-text-right">
                    <FollowButton
                        followCompany={props.followCompany}
                        id="top"
                    />
                </div>
            </div>
        </section>
    );
}

ProfileTopBar.propTypes = {
    profile: PropTypes.object.isRequired,
    followCompany: PropTypes.object.isRequired,
};
